module.exports = __webpack_public_path__ + "img/test.3a9350c2.jpg";